import {Popup, PopupContentProps, PopupProps, RawPopup} from "./Popup";
import './SmallPopup.css'
import './Common.css'
import {closeCross} from "../Icons/Icons";


function SmallPopupBase<T>({props, popupConstructor}: {props: PopupProps<T>, popupConstructor : (p : PopupProps<T>) => JSX.Element }) {
    const contentFactory = (e : PopupContentProps<T>) => {
        const mainContent = props.contentFactory(e);

        const outerClassName = props.isOpen
            ? "full-size flex-center small-popup-outer"
            : "full-size flex-center small-popup-outer small-popup-outer-hidden";
        const innerClassName = props.isOpen
            ? "small-popup-content"
            : "small-popup-content small-popup-content-hidden";

        return <div className={outerClassName}>
            <div className={innerClassName}>
                <div className="flex-right full-wide">
                    <div className="cancel-cross-outer" onClick={() => props.setIsOpen(false)}> {closeCross} </div>
                </div>
                {mainContent}
            </div>
        </div>
    }

    const popupProps = {
        isOpen: props.isOpen,
        setIsOpen: props.setIsOpen,
        contentFactory: contentFactory,
        data: props.data,
        zIndex: 10
    }

    return popupConstructor(popupProps);
}

export function SmallPopup<T>(props: PopupProps<T>){
    return <SmallPopupBase props={props} popupConstructor={p => <Popup {...p}/>}/>
}

export function SmallPopupRaw<T>(props: PopupProps<T>){
    return <SmallPopupBase props={props} popupConstructor={p => <RawPopup {...p}/>}/>
}